
// You can write more code here

/* START OF COMPILED CODE */

import Phaser from "phaser";
/* START-USER-IMPORTS */
import Tween = Phaser.Tweens.Tween;
/* END-USER-IMPORTS */

export default class ScoreMultiplierNotification extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // label
    const label = scene.add.text(0, 0, "", {});
    label.setOrigin(0.5, 0.5);
    label.text = "2x";
    label.setStyle({ "fontFamily": "Acme-Regular", "fontSize": "30px" });
    this.add(label);

    this.label = label;

    /* START-USER-CTR-CODE */

    /* END-USER-CTR-CODE */
  }

  private label: Phaser.GameObjects.Text;

  /* START-USER-CODE */
  private tween!:Tween;

  public show(scoreMultiplier:number)
  {
    this.label.text = scoreMultiplier+this.scene.app.LocaleHandler.getLocalisedTextById("multiplierPostFix");
    if(this.tween != undefined)
    {
      this.tween.stop();
    }
    this.alpha = 1;
    this.visible = true;

    this.tween = this.scene.add.tween({
      targets: this,
      y: this.y - 100,
      alpha:0,
      duration: 1000,
      ease: "Quad.InOut"
    });

    this.tween.on("complete",()=>{
      this.visible = false;
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
